import React from 'react'
import {Box,Stack,Typography} from '@mui/material'
import Logo from '../assests/images/logo.webp'

const Footer = () => {
  return (
    <Box mt='80px' width='115%' bgcolor='#fff3f4'>
    <Stack gap='40px' alignItems='center' px='24px'>
      <img src={Logo} alt='logo' mt='40px' width='100px' height='120px'/>
      <Typography variant='h5' pb='40px' mt='40px'>
Made with ❤️ by Harshit Gupta
      </Typography>
    </Stack>
    </Box>
  )
}

export default Footer
